import styled from 'styled-components';
import { getUrlWithToken } from '../../../utils/common';

export const Cover = styled.div`
  background-image: url(${({ src }) => getUrlWithToken(src)});
  background-size: cover;
  background-position: center center;
  height: 300px;
  width: 100%;
`;

export const CategoriesWrapper = styled.div`
  position: absolute;
  top: 260px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const CategoryLabel = styled.div`
  width: fit-content;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  background-color: ${(props) => props.theme.colors.bgHeader};
  color: ${(props) => props.theme.colors.white};
  cursor: default;
`;

export const Date = styled.div`
  text-align: right;
  margin-bottom: 1rem;
`;

export const MaterialWrapper = styled.div`
  padding: 40px 0;
  .title {
    margin-bottom: 1rem;
  }

  .cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
`;

export const MaterialCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  width: 100%;
  padding: 20px 0;

  .name {
    width: auto;
    margin-right: auto;
    font-size: 1.2rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FileImg = styled.img`
  width: 30px;
  height: 30px;
  display: block;
`;

export const RelatedWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.bgSecondary};
  padding: 40px 0;
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 2rem;
`;
